<div class="po-row" id="over-login">
  <div *ngIf="isLoading" class="sample-container">
    <po-loading-overlay [p-text]="text" [p-size]="size">
    </po-loading-overlay>
  </div>
  <div class="login po-sm-12 po-md-12 po-lg-6 po-xl-6 login-container" id="mfa">
    <po-page-login [p-background]="background" [p-contact-email]="contactEmail" [p-custom-field]="customField"
      [p-environment]="environment" [p-exceeded-attempts-warning]="exceededAttempts" [p-hide-remember-user]="true"
      [p-loading]="properties.includes('loading')" [p-literals]="customLiterals" [p-login]="login"
      [p-login-errors]="loginErrors" [p-login-pattern]="loginPattern" [p-logo]="logo"
      [p-password-errors]="passwordErrors" [p-password-pattern]="passwordPattern" [p-product-name]="productName"
      [p-register-url]="registerUrl" [p-secondary-logo]="secondaryLogo" [p-support]="support" [p-languages]="languages"
      (p-login-submit)="loginSubmit($event)">
    </po-page-login>
    <po-modal #poModal [p-click-out]="properties.includes('click-out')" [p-hide-close]="true"
      [p-primary-action]="primaryAction" [p-secondary-action]="secondaryAction"
      p-title="Múltiplo fator de autenticação (MFA)">
      <po-input (p-change)="setMfa($event)" type="number" p-icon="an an-lock" p-placeholder="0 0 0 0 0 0"
        [p-maxlength]="6" p-label="Informe o número de autenticação" [(ngModel)]="mfaInput"> </po-input>
    </po-modal>
    <po-modal #poModalBranch [p-click-out]="properties.includes('click-out')" [p-hide-close]="true"
      [p-primary-action]="primaryActionBranch" [p-secondary-action]="secondaryActionBranch"
      p-title="Seleção de Empresa">
      <po-combo name="combo-branch" (p-change)="setBranch($event)" p-icon="an an-building-office"
        p-label="Escolha a Empresa" p-placeholder="Selecione uma Empresa" [p-options]="branchList">
      </po-combo>
    </po-modal>
  </div>
  <div class="po-sm-6 po-md-6 po-lg-6 po-xl-6 login-side-image" id="picture">
    <div id="over"></div>
  </div>
</div>